import React, { Component } from 'react';
import cx from 'classnames';
import { withRouter } from 'react-router-dom';
import MobileSetUpWallet from './mobileSetupLoaderModal';
import DesktopSetUpWallet from './desktopSetupLoaderModal';
import styles from './_setupLoaderModal.module.scss';

class SetupLoaderModal extends Component {
  state = {
    windowSize: 0,
  };

  componentDidMount() {
    this.updateDimensions();
    window.addEventListener('resize', this.updateDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  updateDimensions = () => {
    const windowSize = window.innerWidth;
    this.setState({ windowSize });
  };

  render() {
    const { isModalVisible, closeModal, onConfirm } = this.props;
    const { windowSize } = this.state;
    return (
      <div className={cx(styles['cancel-purchase-page-container'])}>
        <div className={styles['mobile']}>
          <MobileSetUpWallet
            isModalVisible={isModalVisible && windowSize < 991}
            closeModal={closeModal}
            onConfirm={onConfirm}
          />
        </div>
        <div className={styles['desktop']}>
          <DesktopSetUpWallet
            isModalVisible={isModalVisible && windowSize >= 991}
            closeModal={closeModal}
            onConfirm={onConfirm}
          />
        </div>
      </div>
    );
  }
}

export default withRouter(SetupLoaderModal);
